import { ModalWrapper } from 'src/components'
import { LikesGraph } from './graph.component'

import { useStyles } from './styles'

interface IProps {
  open: boolean
  handleClose: () => void
  impactId: string
  impactName: string
}

export const LikesDashboardModal = ({ open, handleClose, impactId, impactName }: IProps) => {
  const classes = useStyles()

  return (
    <ModalWrapper
      onClose={handleClose}
      className={classes.modalWrapper}
      open={open}
      title={impactName}
    >
      <div style={{ width: '100%', height: '100%' }}>
        <LikesGraph impactId={impactId} />
      </div>
    </ModalWrapper>
  )
}
